import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import PostDetail from "../pages/post/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/biaoqingbao",
    element: <CategoryPage slug="biaoqingbao" />,
  },
  {
    path: "/duanzi",
    element: <CategoryPage slug="duanzi" />,
  },
  {
    path: "/shenhuifu",
    element: <CategoryPage slug="shenhuifu" />,
  },
  {
    path: "/gengtu",
    element: <CategoryPage slug="gengtu" />,
  },
  {
    path: "/shipin",
    element: <CategoryPage slug="shipin" />,
  },
  {
    path: "/post/:id",
    element: <PostDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;